/**
 * Workflow configuration defaults
 *  This does not generate a functional workflow without tenant specific input
 *
 * @type {object}
 */
const config = {
  tenantName: '',
  tenantAcronym: '',
  tenantSlug: '',

  /**
   * Feature Access checks
   *
   * @type {Object}
   */
  access: {
    'requestlist': [],
    'requestlocations': [],
    'realisationlist': [],
    'locationList': [],
    'realisationbtn': [],
    'realisationcomment': [],
    'canConfirmTrafficDecisions': [],
    'canChangeCommentStatus': [],
    'canModerateComments': [],
    'canChangeStatus': [],
    'automatedViews': [],
    'generateStartDoc': [],
    'admin': [],
    'reporting': [],
    'manuals': [],
    'canAccessDebugger': [],
    'export': [],
  },


  /**
   * Judgement Reasons
   *
   * @type {Object[]}
   */
  reasonOptions: [],


  /**
   * Monitoring config
   *
   * @type {Object}
   */
  monitoring: {
    enabled: false,
    limit: 0.5,
  },

  /**
   * Diameter of the location picker in meters
   */
  LocationPickerDiameter: 200,

  /**
   * Logo and other possible tenant images config
   */
  image: {
    file: 'evtools.png',
    width: 130,
  },

  /**
   * Mapbox Map & address finder options
   */
  mapOptions: {
    countries: 'nl',
    center: [4.9041, 52.3676],
    zoom: 11,
  },

    // Enable the possibility to reset or cancel already saved date
    canResetDateValue: false,

   /**
   * CPO field specific
   */
  chargePointOperatorField: {
    'type': 'string',
    'title': 'CPO',
    'disabled': true,
  },
   /**
   * DateOfCommissioning fields (all tenants exc. Amsterdam)
   */
  DateOfCommissioningFields: {
    'DateOfCommissioning': {
      'type': 'string',
      'title': 'Datum in bedrijf genomen',
      'format': 'date',
    },
    'DateOfEnergyConnection': {
      'type': 'string',
      'title': 'Datum aanmelding energieleverancier',
      'format': 'date',
    },
    'EAN': {
      'type': 'string',
      'title': 'EAN',
      'format': 'text',
    },
  },
  /**
   * PNC Step 6 preparation date fields
   */
  preparationDateFields: {
    'GridOperatorContract': {
      'type': 'string',
      'title': 'Tekendatum offerte netbeheerder',
      'format': 'date',
    },
    'ChargePointOrderDate': {
      'type': 'string',
      'title': 'Besteldatum laadpaal',
      'format': 'date',
    },
  },

  usesPlannedRealisationFields: true,

  /**
   * search
   *
   * @type {Object}
   */
  search: {
    requests: {
      keys: [],
      placeholder: '',
    },
    realisations: {
      keys: [],
      placeholder: '',
    },
  },
  /**
   * Realisation statuses used for layers filtering. If true => visible
   *  default: In the RP maps we hide RQs that are connected to completed RPs.
   *
   * @type {Object[]}
   */
  visibleRequestsByRealisationStatuses: {
    completed: false,
    cancelled: true,
    onhold: true,
  },
  /**
     * Visible realisations within map (toggle)
     *
     * @type {Object[]}
   */
  visibleRecordsByStatus: {
    completed: true,
    cancelled: false,
  },

  tour: {
    date: '11052023',
    email: 'support@evtools.nl',
    'RealisationListFiltered': {
      name: 'Realisatieprocessen',
      steps: [
        {
          target: '#vkb-filter',
          header: {
            title: 'Nieuwe VKB status toegevoegd',
          },
          content: '<p>Nieuw: <b>Geen VKB</b> status is toegevoegd zodat realisatieprocessen waarbij geen verkeerbesluit is genomen gemakkelijk terug te vinden zijn.</p>',
          params: {
            placement: 'bottom-start',
          },
        },
        {
          target: '.TableControls__icons',
          access: 'export',
          header: {
            title: 'Extra velden in de Excel export',
          },
          content: '<p><b>Netbeheerdernummer</b>, <b>Aansluitwaarde</b> en <b>EAN</b> zijn toegevoegd aan de Excel export.</p>',
          params: {
            placement: 'bottom-start',
          },
        },
      ],
    },
    'Realisation.Step1': {
      name: 'realisatieproces stap 1',
      steps: [
        {
          target: '.GridOperatorApproval .FieldSet div:first-of-type fieldset',
          header: {
            title: 'Nieuw: Laadpaaluitvoering',
          },
          content: '<p>Selecteer de uitvoering van de te plaatsen laadpaal als deze bekend is. Nog geen uitvoeringen beschikbaar om uit te kiezen? Mail de gewenste uitvoeringen, merk + model + kleur + artikelnummer, naar <a href="mailto:support@evtools.nl">support@evtools.nl</a>. Laadpaaluitvoering is tevens toegevoegd aan het Startdocument en de Export.</p>',
          params: {
            placement: 'bottom-start',
          },
        },
      ],
    },
    'Realisation.Step4': {
      name: 'realisatieproces stap 4',
      steps: [
        {
          target: '.TrafficDecision .FieldSet div:first-of-type',
          header: {
            title: 'Plaatsen zonder verkeersbesluit',
          },
          content: '<p>In een aantal gemeenten is het mogelijk om laadpalen te plaatsen zonder verkeersbesluit. Je kunt daarom nu in een realisatieproces aangeven of je wel/niet een Verkeerbesluit gaat nemen met de toggle <b>Verkeersbesluit niet van toepassing</b>. Als je de toggle aanzet, kun je door naar de Volgende Stap zonder VKB datums in te vullen.</p>',
          params: {
            placement: 'bottom-start',
          },
        },
      ],
    },
    'Realisation.Step5': {
      name: 'realisatieproces stap 5',
      steps: [
        {
          target: '.GridConnection .FormField:nth-child(2)',
          header: {
            title: 'Nieuw: Netbeheerdernummer veld',
          },
          content: '<p>Je kunt nu ook het <b>Netbeheerdernummer</b> opslaan. Dit veld komt ook terug in de Excel export functionaliteit.</p>',
          params: {
            placement: 'bottom-start',
          },
        },
        {
          target: '.GridConnection .FormField:nth-child(3)',
          header: {
            title: 'Nieuw: Aansluitwaarde veld',
          },
          content: '<p>Je kunt nu ook de <b>Aansluitwaarde</b> opslaan. Dit veld komt ook terug in de Excel export functionaliteit.</p>',
          params: {
            placement: 'bottom-start',
          },
        },
      ],
    },
    'Realisation.Step7': {
      name: 'realisatieproces stap 7',
      steps: [
        {
          target: '.Row .FormField:last-child',
          header: {
            title: 'Nieuw: EAN veld',
          },
          content: '<p>Je kunt nu ook de <b>EAN</b> opslaan. Dit veld komt ook terug in de Excel export functionaliteit.</p>',
          params: {
            placement: 'bottom-start',
          },
        },
      ],
    },
    'RealisationProcessTimeInSteps': {
      name: 'Rapportage: Gemiddeld aantal dagen doorlooptijd realisatie processen',
      steps: [
        {
          target: '.p-datatable-header',
          header: {
            title: 'Benchmark en filters selecteren',
          },
          content: '<p>Gebruik van de benchmark en/of filters resulteert in een herberekening van de gemiddelde Stap- en Totaaltijden. De kolommen kunnen op- en aflopend worden gesorteerd (weergegeven met gerelateerde kleur).</p>',
          params: {
            placement: 'bottom-start',
          },
          before: (type) => new Promise((resolve) => {
            const selector = document.querySelector('div.p-datatable-wrapper tr:nth-child(1) > td:first-child .p-link')
            type !== 'start' && selector.click()
            resolve()
          }),
        },
        {
          target: '.showDetails',
          header: {
            title: 'Realisaties van de benchmark item',
          },
          content: '<p>Elke regel kan worden uitgevouwen om het specifieke realisatie proces te openen. Daarbij wordt per realisatie de duur van elke stap in dagen getoond en gepresenteerd met bijbehorende kleur.</p>',
          params: {
            placement: 'bottom',
          },
          before: () => new Promise((resolve) => {
            const selector = document.querySelector('div.p-datatable-wrapper tr:nth-child(1) > td:first-child .p-link')
            selector.click()
            setTimeout(() => {
              resolve()
            }, 250)
          }),
        },
        {
          target: '.p-datatable-tfoot',
          header: {
            title: 'Totaal gemiddeld per kolom',
          },
          content: '<p>Afhankelijk van de geselecteerde benchmark wordt hier de gemiddelde waarde per kolom getoond.</p>',
          params: {
            placement: 'top',
          },
          before: () => new Promise((resolve) => {
            const selector = document.querySelector('div.p-datatable-wrapper tr:nth-child(1) > td:first-child .p-link')
            selector.click()
            resolve()
          }),
        },
      ],
    },
    // Add tour dynamically to all Realisation.Step routes //
    addTourStepToRealisationStepRoutes: ({ target }) => {
      const doc = {
        target,
        isOnAllSteps: true,
        header: {
          title: 'Aannemer in startdocument',
        },
        content: '<p><b>Aannemer</b> staat nu ook in het automatisch gegenereerd startdocument.</p>',
        params: {
          placement: 'bottom-start',
        },
      }
      config.steps.forEach(step => {
        const stepTour = config.tour['Realisation.Step' + step.step]

        if (stepTour?.steps) {
          config.tour['Realisation.Step' + step.step].steps.push(doc)
        } else {
          config.tour[`Realisation.Step${step.step}`] =
            {
              name: `realisatieproces stap ${step.step}`,
              steps: [{ ...doc }],
            }
        }
      })
    },
  },
  /**
   * onHold & cancel reasons
   *
   * @type {Object[]}
   */
  onHoldReasons: [],

  /**
   * @type {Object[]}
   */
  cancelReasons: [],

  ChargingStationVersion: [],

  /**
   * Municipality Options
   *
   * @type {Object[]}
   */
  municipalityOptions: [],

   /**
   * Mapbox Map Request view show/hide active layer red marker
   */
  requestMapShowActiveRedMarker: true,


  /**
   * Commonly used contractors by municipality
   * @type {Object}
   */
   contractorsByMunicipalityCode: {},
   operatorsByMunicipalityCode: {},

  /**
   * Reporting default menu
   *
   * @type {Object[]}
   */
  ReportingMenu: [
    {
      type: 'link',
      label: 'Key Metrics',
      to: {
        name: 'KeyMetrics',
      },
    },
    {
      type: 'segment',
      label: 'Aanvragen',
      items: [{
        type: 'link',
        label: 'Beoordelingen',
        to: {
          name: 'RequestJudgement',
        },
      }],
    },
    {
      type: 'segment',
      label: 'Realisatie',
      items: [
        {
          type: 'link',
          label: 'Statusoverzicht',
          to: {
            name: 'RealisationProcessStatus',
          },
        },
        {
          type: 'link',
          label: 'Doorlooptijd van stappen',
          to: {
            name: 'RealisationProcessTimeInSteps',
          },
        },
      ],
    },
  ],


  /**
   * Manuals default menu
   *
   * @type {Object[]}
   */
  ManualsMenu: [
    {
      type: 'segment',
      label: 'Workflow handleiding',
      items: [
        {
          type: 'link',
          label: 'Inleiding',
          to: {
            name: 'ManualPage',
            params: { slug: 'inleiding' },
          },
          securityCheck: 'manuals',
        },
        {
          type: 'link',
          label: 'Gebruikersprofiel',
          to: {
            name: 'ManualPage',
            params: { slug: 'gebruikersprofiel' },
          },
          securityCheck: 'manuals',
        },
        {
          type: 'segment',
          label: 'Aanvragen',
          securityCheck: 'realisationlist',
          items: [{
            type: 'link',
            label: 'De overzichtspagina',
            to: {
              name: 'ManualPage',
              params: { slug: 'aanvragenoverzicht' },
            },
          },
          {
            type: 'link',
            label: 'Aanvragen beoordelen',
            to: {
              name: 'ManualPage',
              params: { slug: 'aanvragen-beoordelen' },
            },
          }],
        },
        {
          type: 'segment',
          label: 'Realisatieprocessen',
          securityCheck: 'requestlist',
          items: [{
            type: 'link',
            label: 'De overzichtspagina',
            to: {
              name: 'ManualPage',
              params: { slug: 'realisatieprocessenoverzicht' },
            },
          },
          {
            type: 'link',
            label: 'Starten van een proces',
            to: {
              name: 'ManualPage',
              params: { slug: 'realisatieproces-starten' },
            },
            securityCheck: 'realisationbtn',
          },
          {
            type: 'link',
            label: 'Doorlopen van stappen',
            to: {
              name: 'ManualPage',
              params: { slug: 'doorlopen-realisatieproces' },
            },
          },
          {
            type: 'link',
            label: 'On hold of annuleren',
            to: {
              name: 'ManualPage',
              params: { slug: 'realisateproces-onhold-zetten-of-annuleren' },
            },
            securityCheck: 'canChangeStatus',
          }],
        },
      ],
    },
  ],


  /**
   * Admin default menu
   *
   * @type {Object[]}
   */
  AdminMenu: [
    {
      type: 'segment',
      label: 'Configuratie',
      items: [
        {
          type: 'link',
          label: 'Beschikbare tags',
          to: {
            name: 'TagsConfig',
          },
        },
      ],
    },
  ],
  /**
   * Default benchmark menu, used in realisation reporting average step time
   *
   * @type {Object}
   */
  benchmarkMenu: [
    { name: 'Gemeente', target: 'municipalityOptions' },
    { name: 'Netbeheerder', target: 'gridOperators' },
    { name: 'Aannemer', target: 'getEnabledContractors' },
    { name: 'Type realisatieproces', target: 'getProcessTypeOptions' },
    { name: 'Aantal palen per RP', target: 'recordsByNumberOfChargingStations' },
  ],
  /**
     * Step 5 Grid connection dropdown values
     *
     * @type {Array}
     */
  gridConnectionValues: [
    '1 x 25 A',
    '1 x 35 A',
    '1 x 40 A',
    '3 x 25 A',
    '3 x 35 A',
    '3 x 50 A',
    '3 x 63 A',
    '3 x 80 A',
    '3 x 100 A',
    '3 x 125 A',
    '3 x 160 A',
    '3 x 250 A',
    '3 x 400 A',
    '3 x 500 A',
    '3 x 630 A',
    '160 kVA',
    '250 kVA',
    '400 kVA',
    '630 kVA',
    '1750 kVA',
    '2000 kVA',
  ],
  /**
   * Default time-based VKB statuses, used for filtering in realisation list
   *
   * @type {Object}
   */
  vkbStatuses: ({ record, Location }) => {
    const now = Date.now()

    let vkb = 'Onbekende status'
    let vkb_sorting = 9999

    if (record.getStatus({ name: 'vkb' })) {
      vkb = 'Onherroepelijk'
      vkb_sorting = 1
    } else if (Location) {
      // Location
      const TrafficDecisionDetails = Location.getTrafficDecisionDetails()
      if (TrafficDecisionDetails.TrafficDecisionNotApplicable) {
        vkb = 'Geen VKB'
        vkb_sorting = 99
      } else if (! TrafficDecisionDetails.PublicationDate) {
        vkb = 'Nog te publiceren'
        vkb_sorting = 100
      } else if (TrafficDecisionDetails.ConfirmedDate) {
        vkb = 'Onherroepelijk'
        vkb_sorting = 1
      } else if (TrafficDecisionDetails.DefinitiveDate) {
        const date = (new Date(TrafficDecisionDetails.DefinitiveDate)).getTime()

        // Already passed
        if (date < now) {
          vkb = 'Verlopen'
          vkb_sorting = 2
        } else {
          const diffInMs = date - now
          const diffInDays = diffInMs / (1000 * 60 * 60 * 24)
          const diffInWeeks = diffInDays / 7

          if (diffInDays < 2) {
            vkb = 'Nog max 2 dagen'
            vkb_sorting = 3
          } else if (diffInDays < 7) {
            vkb = 'Nog max 7 dagen'
            vkb_sorting = 4
          } else if (diffInDays <= 14) {
            vkb = 'Nog max 14 dagen'
            vkb_sorting = 5
          } else if (diffInWeeks >= 2 && diffInWeeks < 4 ) {
            vkb = 'Nog 2-4 weken'
            vkb_sorting = 6
          } else if (diffInWeeks >= 4 && diffInWeeks <= 6 ) {
            vkb = 'Nog 4-6 weken'
            vkb_sorting = 7
          } else if (diffInWeeks > 6 ) {
            vkb = 'Nog meer dan 6 weken'
            vkb_sorting = 8
          }
        }
      }
    }

    return { vkb, vkb_sorting }
  },

  /**
   * Steps
   */
   steps: [
    {
      step: 1,
      uuid: '63a4d7f6-f3d1-4030-9637-66386d2f876b',
      component: require('@/views/park-n-charge/RealisationStep1'),
      version: 1,
      label: 'Locatievoorstel',
      access: {
        read: ['municipality', 'cpo'],
        edit: ['cpo'],
      },
    },
    {
      step: 2,
      uuid: '7fc0ed9a-f715-472e-9f7a-67152f3eecaa',
      component: require('@/views/park-n-charge/RealisationStep2'),
      version: 1,
      label: 'Gemeente beoordeling',
      access: {
        read: ['municipality', 'cpo'],
        edit: ['municipality'],
      },
    },
    {
      step: 3,
      uuid: 'd9e54a80-1d1d-4d61-a58d-df4d6a719fcb',
      component: require('@/views/park-n-charge/RealisationStep3'),
      version: 1,
      label: 'Verwerking beoordeling',
      access: {
        read: ['municipality', 'cpo'],
        edit: ['cpo'],
      },
    },
    {
      step: 4,
      uuid: 'b3fc2e59-25ee-4792-a1b3-27e69b277ee0',
      component: require('@/views/park-n-charge/RealisationStep4'),
      version: 1,
      label: 'Verkeersbesluit',
      access: {
        read: ['municipality', 'cpo'],
        edit: ['municipality'],
      },
    },
    {
      step: 5,
      uuid: '252575b0-3ab6-4de3-82af-4cdd83ec6705',
      component: require('@/views/park-n-charge/RealisationStep5'),
      version: 1,
      label: 'Aanvragen netaansluiting',
      access: {
        read: ['municipality', 'cpo'],
        edit: ['cpo'],
      },
    },
    {
      step: 6,
      uuid: '5f4ade07-5a0a-471c-bed8-3d6b2316c0b8',
      component: require('@/views/park-n-charge/RealisationStep6'),
      version: 1,
      label: 'Plan realisatie',
      access: {
        read: ['municipality', 'cpo'],
        edit: ['cpo'],
      },
    },
    {
      step: 7,
      uuid: '1c146862-f847-4b63-b21c-15593b61bdeb',
      component: require('@/views/park-n-charge/RealisationStep7'),
      version: 1,
      label: 'Realisatie en inbedrijfstelling',
      access: {
        read: ['municipality', 'cpo'],
        edit: ['cpo'],
      },
    },
    {
      step: 8,
      uuid: '0c985c06-9a98-445f-93da-047a76d2117f',
      component: require('@/views/park-n-charge/RealisationStep8'),
      version: 1,
      label: 'SAT',
      access: {
        read: ['municipality', 'cpo'],
        edit: ['cpo'],
      },
    },
  ],

  supportEmailAddress: 'support@evtools.nl',
}
// Remove all old tours based on route name //
const tourRoutesMatch = /^RealisationListFiltered$|^Realisation.Step\d?$|^RequestDetail$/
Object.keys({ ...localStorage }).map(key => {
  if (tourRoutesMatch.test(key)) {
    localStorage.removeItem(key)
  }
})

const isTourSeen = Object.keys({ ...localStorage }).some(key => key.startsWith('Realisation.Step'))
if (!isTourSeen) {
  config.tour.addTourStepToRealisationStepRoutes({ target: '#document-download' })
}

export default config
